export const seoQuery = /* groq */ `
  ...,
  image {
    ...,
    "url": asset->url,
  }
`;

export default seoQuery.replace(/ +/g, '');
